module.exports = __webpack_public_path__ + "static/media/publish.bf65d6b5.svg";